import Vue from 'vue'
import i18n from '@/plugins/i18n'
const moment = require('moment')
require('moment/locale/es')

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value.toString().toUpperCase()
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  const val = value.toString()
  return `${val[0].toUpperCase()}${val.substr(1)}`
})

Vue.filter('date_format', function (value) {
  const date = moment(value).format('DD-MM-YYYY')
  return date
})

Vue.filter('number', function(number){
  if (!number) return 0
  return number.toString()
      .replace(/^0/, '')
      .replace(/\./, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})

Vue.filter('money', function (value) {
  return Number(value).toLocaleString(i18n.locale === 'en' ? 'en' : 'es')
})

Vue.filter('rutificador', function (value) {
  if (!value) return '---'
  let rut = value.split('').reverse().join('')
  let inverse = `${rut.slice(0, 1)}-${rut.slice(1, 4)}.${rut.slice(4, 7)}.${rut.slice(7, rut.length)}`
  return inverse.split('').reverse().join('')
})
